import { render, staticRenderFns } from "./SegmentedTrendsLandingTable.vue?vue&type=template&id=7c35ab83&scoped=true"
import script from "./SegmentedTrendsLandingTable.vue?vue&type=script&lang=ts"
export * from "./SegmentedTrendsLandingTable.vue?vue&type=script&lang=ts"
import style0 from "./SegmentedTrendsLandingTable.vue?vue&type=style&index=0&id=7c35ab83&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c35ab83",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/segmented-trends/segmented-trends-landing-table.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsegmented-trends%2FSegmentedTrendsLandingTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports